/**
 * Mock data pre oznámenia (statements)
 */

import { officials, ovmIds, countryIds, municipalityIds } from "./officials";

const generateDate = (yearsAgo, monthOffset = 0, dayOffset = 0) => {
  const date = new Date();
  date.setFullYear(date.getFullYear() - yearsAgo);
  date.setMonth(date.getMonth() + monthOffset);
  date.setDate(date.getDate() + dayOffset);
  return date.toISOString();
};

// Typy oznámení
const STATEMENT_TYPES = {
  INGOING: "INGOING", // Vstupné
  ONGOING: "ONGOING", // Priebežné
  OUTGOING: "OUTGOING", // Výstupné
  POINT3: "POINT3", // Podľa bodu 3
};

// Stavy oznámení
const STATEMENT_STATES = {
  NEW: "NEW",
  ACCEPT: "ACCEPT",
  INCOMPLETE: "INCOMPLETE",
  REJECT: "REJECT",
};

// Generátor majetkových položiek
const generateRealEstate = (count) => {
  const types = ["byt", "rodinný dům", "pozemek", "garáž", "chata"];
  const municipalities = [
    { id: municipalityIds.praha, name: "Praha" },
    { id: municipalityIds.brno, name: "Brno" },
    { id: municipalityIds.ostrava, name: "Ostrava" },
    { id: municipalityIds.plzen, name: "Plzeň" },
  ];

  return Array.from({ length: count }, (_, i) => ({
    id: `realestate-${Date.now()}-${i}`,
    type: types[Math.floor(Math.random() * types.length)],
    ownership: Math.random() > 0.3 ? "EXCLUSIVE" : "SHARED",
    shareSize:
      Math.random() > 0.3 ? null : `1/${Math.floor(Math.random() * 4) + 2}`,
    acquisitionDate: generateDate(Math.floor(Math.random() * 10) + 1),
    acquisitionMethod: Math.random() > 0.5 ? "PURCHASE" : "INHERITANCE",
    municipality:
      municipalities[Math.floor(Math.random() * municipalities.length)],
  }));
};

// Generátor príjmov
const generateIncomes = (baseIncome, count) => {
  const sources = [
    "plat",
    "odměna za výkon funkce",
    "autorské honoráře",
    "příjmy z pronájmu",
    "dividendy",
  ];

  return Array.from({ length: count }, (_, i) => ({
    id: `income-${Date.now()}-${i}`,
    source: sources[i % sources.length],
    amount: baseIncome + Math.floor(Math.random() * 500000),
    period: "rok",
    description: i === 0 ? "Hlavní příjem ze závislé činnosti" : null,
  }));
};

// Generátor záväzkov
const generateLiabilities = (count) => {
  const types = ["hypotéka", "spotřebitelský úvěr", "půjčka"];

  return Array.from({ length: count }, (_, i) => ({
    id: `liability-${Date.now()}-${i}`,
    type: types[i % types.length],
    amount: Math.floor(Math.random() * 5000000) + 500000,
    creditor: i === 0 ? "Česká spořitelna" : "Komerční banka",
  }));
};

export const statements = [
  // Vstupné oznámenie - Jan Novák
  {
    id: "stmt-001-001",
    officialId: officials[0].id,
    official: {
      id: officials[0].id,
      firstName: officials[0].firstName,
      lastName: officials[0].lastName,
      titleBefore: officials[0].titleBefore,
      titleAfter: officials[0].titleAfter,
    },
    type: STATEMENT_TYPES.INGOING,
    state: STATEMENT_STATES.ACCEPT,
    year: 2022,
    creationDate: generateDate(2),
    submissionDate: generateDate(2, 0, 5),
    acceptDate: generateDate(2, 0, 10),
    ovmId: ovmIds.ministerstvo,
    ovmName: "Ministerstvo financí",
    visibility: "PUBLIC",
    realEstates: generateRealEstate(2),
    incomes: generateIncomes(1500000, 2),
    liabilities: generateLiabilities(1),
    securities: [],
    otherAssets: [],
    gifts: [],
  },
  // Priebežné oznámenie 2023 - Jan Novák
  {
    id: "stmt-001-002",
    officialId: officials[0].id,
    official: {
      id: officials[0].id,
      firstName: officials[0].firstName,
      lastName: officials[0].lastName,
      titleBefore: officials[0].titleBefore,
      titleAfter: officials[0].titleAfter,
    },
    type: STATEMENT_TYPES.ONGOING,
    state: STATEMENT_STATES.ACCEPT,
    year: 2023,
    creationDate: generateDate(1),
    submissionDate: generateDate(1, 0, 3),
    acceptDate: generateDate(1, 0, 8),
    ovmId: ovmIds.ministerstvo,
    ovmName: "Ministerstvo financí",
    visibility: "PUBLIC",
    realEstates: generateRealEstate(2),
    incomes: generateIncomes(1600000, 2),
    liabilities: generateLiabilities(1),
    securities: [],
    otherAssets: [],
    gifts: [],
  },
  // Nové oznámenie 2024 - Jan Novák
  {
    id: "stmt-001-003",
    officialId: officials[0].id,
    official: {
      id: officials[0].id,
      firstName: officials[0].firstName,
      lastName: officials[0].lastName,
      titleBefore: officials[0].titleBefore,
      titleAfter: officials[0].titleAfter,
    },
    type: STATEMENT_TYPES.ONGOING,
    state: STATEMENT_STATES.NEW,
    year: 2024,
    creationDate: generateDate(0, -1),
    submissionDate: null,
    acceptDate: null,
    ovmId: ovmIds.ministerstvo,
    ovmName: "Ministerstvo financí",
    visibility: "PUBLIC",
    realEstates: [],
    incomes: [],
    liabilities: [],
    securities: [],
    otherAssets: [],
    gifts: [],
  },
  // Vstupné - Marie Svobodová (senátorka)
  {
    id: "stmt-002-001",
    officialId: officials[1].id,
    official: {
      id: officials[1].id,
      firstName: officials[1].firstName,
      lastName: officials[1].lastName,
      titleBefore: officials[1].titleBefore,
      titleAfter: officials[1].titleAfter,
    },
    type: STATEMENT_TYPES.INGOING,
    state: STATEMENT_STATES.ACCEPT,
    year: 2018,
    creationDate: generateDate(5),
    submissionDate: generateDate(5, 0, 7),
    acceptDate: generateDate(5, 0, 14),
    ovmId: ovmIds.senat,
    ovmName: "Senát ČR",
    visibility: "PUBLIC",
    realEstates: generateRealEstate(3),
    incomes: generateIncomes(1200000, 3),
    liabilities: generateLiabilities(2),
    securities: [
      {
        id: "sec-001",
        type: "akcie",
        issuer: "ČEZ, a.s.",
        count: 500,
        value: 250000,
      },
    ],
    otherAssets: [],
    gifts: [],
  },
  // Priebežné 2023 - Marie Svobodová
  {
    id: "stmt-002-005",
    officialId: officials[1].id,
    official: {
      id: officials[1].id,
      firstName: officials[1].firstName,
      lastName: officials[1].lastName,
      titleBefore: officials[1].titleBefore,
      titleAfter: officials[1].titleAfter,
    },
    type: STATEMENT_TYPES.ONGOING,
    state: STATEMENT_STATES.ACCEPT,
    year: 2023,
    creationDate: generateDate(1),
    submissionDate: generateDate(1, 0, 5),
    acceptDate: generateDate(1, 0, 12),
    ovmId: ovmIds.senat,
    ovmName: "Senát ČR",
    visibility: "PUBLIC",
    realEstates: generateRealEstate(3),
    incomes: generateIncomes(1400000, 3),
    liabilities: generateLiabilities(1),
    securities: [
      {
        id: "sec-002",
        type: "akcie",
        issuer: "ČEZ, a.s.",
        count: 600,
        value: 300000,
      },
    ],
    otherAssets: [],
    gifts: [{ id: "gift-001", description: "Knihy", value: 5000 }],
  },
  // Vstupné - Petr Dvořák (radní Praha)
  {
    id: "stmt-003-001",
    officialId: officials[2].id,
    official: {
      id: officials[2].id,
      firstName: officials[2].firstName,
      lastName: officials[2].lastName,
      titleBefore: officials[2].titleBefore,
      titleAfter: officials[2].titleAfter,
    },
    type: STATEMENT_TYPES.INGOING,
    state: STATEMENT_STATES.ACCEPT,
    year: 2022,
    creationDate: generateDate(1, 2),
    submissionDate: generateDate(1, 2, 10),
    acceptDate: generateDate(1, 2, 20),
    ovmId: ovmIds.mestoPraha,
    ovmName: "Magistrát hl. m. Prahy",
    visibility: "REQUEST",
    realEstates: generateRealEstate(4),
    incomes: generateIncomes(900000, 2),
    liabilities: generateLiabilities(2),
    securities: [],
    otherAssets: [
      { id: "asset-001", description: "Osobní automobil BMW", value: 800000 },
    ],
    gifts: [],
  },
  // Priebežné - Petr Dvořák
  {
    id: "stmt-003-002",
    officialId: officials[2].id,
    official: {
      id: officials[2].id,
      firstName: officials[2].firstName,
      lastName: officials[2].lastName,
      titleBefore: officials[2].titleBefore,
      titleAfter: officials[2].titleAfter,
    },
    type: STATEMENT_TYPES.ONGOING,
    state: STATEMENT_STATES.ACCEPT,
    year: 2023,
    creationDate: generateDate(0, -3),
    submissionDate: generateDate(0, -3, 5),
    acceptDate: generateDate(0, -3, 15),
    ovmId: ovmIds.mestoPraha,
    ovmName: "Magistrát hl. m. Prahy",
    visibility: "REQUEST",
    realEstates: generateRealEstate(4),
    incomes: generateIncomes(950000, 2),
    liabilities: generateLiabilities(2),
    securities: [],
    otherAssets: [
      { id: "asset-002", description: "Osobní automobil BMW", value: 750000 },
    ],
    gifts: [],
  },
  // Eva Černá - poslankyně
  {
    id: "stmt-004-001",
    officialId: officials[3].id,
    official: {
      id: officials[3].id,
      firstName: officials[3].firstName,
      lastName: officials[3].lastName,
      titleBefore: officials[3].titleBefore,
      titleAfter: officials[3].titleAfter,
    },
    type: STATEMENT_TYPES.INGOING,
    state: STATEMENT_STATES.ACCEPT,
    year: 2021,
    creationDate: generateDate(2, 2),
    submissionDate: generateDate(2, 2, 7),
    acceptDate: generateDate(2, 2, 14),
    ovmId: ovmIds.snemovna,
    ovmName: "Poslanecká sněmovna",
    visibility: "PUBLIC",
    realEstates: generateRealEstate(1),
    incomes: generateIncomes(1100000, 2),
    liabilities: [],
    securities: [],
    otherAssets: [],
    gifts: [],
  },
  // Eva Černá - nové oznámenie
  {
    id: "stmt-004-003",
    officialId: officials[3].id,
    official: {
      id: officials[3].id,
      firstName: officials[3].firstName,
      lastName: officials[3].lastName,
      titleBefore: officials[3].titleBefore,
      titleAfter: officials[3].titleAfter,
    },
    type: STATEMENT_TYPES.ONGOING,
    state: STATEMENT_STATES.NEW,
    year: 2024,
    creationDate: generateDate(0, -1),
    submissionDate: null,
    acceptDate: null,
    ovmId: ovmIds.snemovna,
    ovmName: "Poslanecká sněmovna",
    visibility: "PUBLIC",
    realEstates: [],
    incomes: [],
    liabilities: [],
    securities: [],
    otherAssets: [],
    gifts: [],
  },
  // Tomáš Procházka - primátor Brno
  {
    id: "stmt-005-001",
    officialId: officials[4].id,
    official: {
      id: officials[4].id,
      firstName: officials[4].firstName,
      lastName: officials[4].lastName,
      titleBefore: officials[4].titleBefore,
      titleAfter: officials[4].titleAfter,
    },
    type: STATEMENT_TYPES.INGOING,
    state: STATEMENT_STATES.ACCEPT,
    year: 2018,
    creationDate: generateDate(6),
    submissionDate: generateDate(6, 0, 10),
    acceptDate: generateDate(6, 0, 20),
    ovmId: ovmIds.mestoBrno,
    ovmName: "Statutární město Brno",
    visibility: "REQUEST",
    realEstates: generateRealEstate(3),
    incomes: generateIncomes(800000, 2),
    liabilities: generateLiabilities(1),
    securities: [],
    otherAssets: [],
    gifts: [],
  },
  // Lucie Veselá - starostka Roztoky
  {
    id: "stmt-006-001",
    officialId: officials[5].id,
    official: {
      id: officials[5].id,
      firstName: officials[5].firstName,
      lastName: officials[5].lastName,
      titleBefore: officials[5].titleBefore,
      titleAfter: officials[5].titleAfter,
    },
    type: STATEMENT_TYPES.INGOING,
    state: STATEMENT_STATES.ACCEPT,
    year: 2022,
    creationDate: generateDate(2),
    submissionDate: generateDate(2, 0, 5),
    acceptDate: generateDate(2, 0, 10),
    ovmId: ovmIds.obecRoztoky,
    ovmName: "Obec Roztoky",
    visibility: "PUBLIC",
    realEstates: generateRealEstate(1),
    incomes: generateIncomes(600000, 1),
    liabilities: [],
    securities: [],
    otherAssets: [],
    gifts: [],
  },
  // Lucie Veselá - nové
  {
    id: "stmt-006-002",
    officialId: officials[5].id,
    official: {
      id: officials[5].id,
      firstName: officials[5].firstName,
      lastName: officials[5].lastName,
      titleBefore: officials[5].titleBefore,
      titleAfter: officials[5].titleAfter,
    },
    type: STATEMENT_TYPES.ONGOING,
    state: STATEMENT_STATES.NEW,
    year: 2024,
    creationDate: generateDate(0, -2),
    submissionDate: null,
    acceptDate: null,
    ovmId: ovmIds.obecRoztoky,
    ovmName: "Obec Roztoky",
    visibility: "PUBLIC",
    realEstates: [],
    incomes: [],
    liabilities: [],
    securities: [],
    otherAssets: [],
    gifts: [],
  },
  // Karel Malý - bývalý hejtman - výstupné
  {
    id: "stmt-007-009",
    officialId: officials[6].id,
    official: {
      id: officials[6].id,
      firstName: officials[6].firstName,
      lastName: officials[6].lastName,
      titleBefore: officials[6].titleBefore,
      titleAfter: officials[6].titleAfter,
    },
    type: STATEMENT_TYPES.OUTGOING,
    state: STATEMENT_STATES.ACCEPT,
    year: 2025,
    creationDate: generateDate(0, -7),
    submissionDate: generateDate(0, -7, 5),
    acceptDate: generateDate(0, -7, 10),
    ovmId: ovmIds.krajBrno,
    ovmName: "Jihomoravský kraj",
    visibility: "PUBLIC",
    realEstates: generateRealEstate(5),
    incomes: generateIncomes(1000000, 3),
    liabilities: generateLiabilities(1),
    securities: [
      {
        id: "sec-003",
        type: "dluhopisy",
        issuer: "ČR",
        count: 10,
        value: 100000,
      },
    ],
    otherAssets: [
      { id: "asset-003", description: "Sbírka obrazů", value: 500000 },
    ],
    gifts: [],
  },
  // Alena Krejčí - náměstkyně (tajné)
  {
    id: "stmt-008-001",
    officialId: officials[7].id,
    official: {
      id: officials[7].id,
      firstName: officials[7].firstName,
      lastName: officials[7].lastName,
      titleBefore: officials[7].titleBefore,
      titleAfter: officials[7].titleAfter,
    },
    type: STATEMENT_TYPES.INGOING,
    state: STATEMENT_STATES.ACCEPT,
    year: 2022,
    creationDate: generateDate(3),
    submissionDate: generateDate(3, 0, 7),
    acceptDate: generateDate(3, 0, 14),
    ovmId: ovmIds.ministerstvoPrace,
    ovmName: "Ministerstvo práce a sociálních věcí",
    visibility: "SECRET",
    realEstates: generateRealEstate(2),
    incomes: generateIncomes(1300000, 2),
    liabilities: generateLiabilities(1),
    securities: [],
    otherAssets: [],
    gifts: [],
  },
  // Petra Němcová - nekompletné oznámenie
  {
    id: "stmt-012-002",
    officialId: officials[11].id,
    official: {
      id: officials[11].id,
      firstName: officials[11].firstName,
      lastName: officials[11].lastName,
      titleBefore: officials[11].titleBefore,
      titleAfter: officials[11].titleAfter,
    },
    type: STATEMENT_TYPES.ONGOING,
    state: STATEMENT_STATES.INCOMPLETE,
    year: 2024,
    creationDate: generateDate(0, -3),
    submissionDate: generateDate(0, -3, 5),
    acceptDate: null,
    incompleteReason: "Chybí informace o příjmech z vedlejší činnosti.",
    ovmId: ovmIds.ministerstvo,
    ovmName: "Ministerstvo financí",
    visibility: "REQUEST",
    realEstates: generateRealEstate(1),
    incomes: generateIncomes(1100000, 1),
    liabilities: [],
    securities: [],
    otherAssets: [],
    gifts: [],
  },
  // Ondřej Beneš - nový hejtman - vstupné nové
  {
    id: "stmt-015-001",
    officialId: officials[14].id,
    official: {
      id: officials[14].id,
      firstName: officials[14].firstName,
      lastName: officials[14].lastName,
      titleBefore: officials[14].titleBefore,
      titleAfter: officials[14].titleAfter,
    },
    type: STATEMENT_TYPES.INGOING,
    state: STATEMENT_STATES.NEW,
    year: 2025,
    creationDate: generateDate(0, -3),
    submissionDate: null,
    acceptDate: null,
    ovmId: ovmIds.krajBrno,
    ovmName: "Jihomoravský kraj",
    visibility: "PUBLIC",
    realEstates: [],
    incomes: [],
    liabilities: [],
    securities: [],
    otherAssets: [],
    gifts: [],
  },
];

// Grid verzie pre rôzne zobrazenia
export const statementsGrid = statements.map((stmt) => ({
  id: stmt.id,
  officialId: stmt.officialId,
  officialName:
    `${stmt.official.titleBefore || ""} ${stmt.official.firstName} ${stmt.official.lastName} ${stmt.official.titleAfter || ""}`.trim(),
  type: stmt.type,
  state: stmt.state,
  year: stmt.year,
  creationDate: stmt.creationDate,
  ovmName: stmt.ovmName,
  visibility: stmt.visibility,
}));

// Verejné oznámenia
export const statementsPublic = statements
  .filter(
    (stmt) =>
      stmt.visibility === "PUBLIC" && stmt.state === STATEMENT_STATES.ACCEPT,
  )
  .map((stmt) => ({
    id: stmt.id,
    officialName:
      `${stmt.official.titleBefore || ""} ${stmt.official.firstName} ${stmt.official.lastName} ${stmt.official.titleAfter || ""}`.trim(),
    type: stmt.type,
    year: stmt.year,
    ovmName: stmt.ovmName,
  }));

export { STATEMENT_TYPES, STATEMENT_STATES };
export default statements;
